// export const eplStyles = {
//     // SIMPLE PATTERN (as before)
//     ThousandSeparator: {
//         name: "Thousand Separator",
//         description: "Add commas to numbers",
//         pattern: /\b\d{4,}\b/g,
//         markerClass: "ace-Common-highlight",

//         getSuggestion: (matchedText) => {
//             return matchedText.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         }
//     },
//     TimeFormate: {
//         name: "Time Format",
//         description: "Convert AM/PM to a.m./p.m.",
//         markerClass: "ace-Common-highlight",

//         pattern: /\b(AM|PM)\b/gi,

//         getSuggestion: (matchedText) => {
//             return matchedText.toLowerCase() === "am" ? "a.m." : "p.m.";
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },

//     PercentageSymbol: {
//         name: "Change Percentage to %",
//         description: "Change Percentage words to %",
//         markerClass: "ace-Common-highlight",

//         pattern: /\b(\d+)\s*(percent|percentage)\b/gi,

//         getSuggestion: (matchedText) => {
//             return matchedText.replace(/\b(\d+)\s*(percent|percentage)\b/gi, "$1%");
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },

//     TemperatureFormatting: {
//         name: "Temperature Formatting",
//         description: "Remove space before and after °",
//         markerClass: "ace-Common-highlight",

//         pattern: /(\d+)\s*°\s*([A-Z]{1,2})/gi,

//         getSuggestion: (matchedText) => {
//             return matchedText.replace(/(\d+)\s*°\s*([A-Z]{1,2})/gi, "$1°$2");
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },

//     PFormatting: {
//         name: "Formatting the p",
//         description: "Changing the letter 'p' to italic 𝑝",
//         markerClass: "ace-Common-highlight",

//         pattern: /(?:(?<=^)|(?<=\s))p(?=\s)/gmi,

//         getSuggestion: (matchedText) => {
//             return matchedText.replace(/(?:(?<=^)|(?<=\s))p(?=\s)/gmi, "𝑝");
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },
//     RangesAndUnits: {
//         name: "Ranges and Units",
//         description: "Normalize ranges, keep only one unit at the end ex: 1ml -2ml -> 1-2ml",
//         markerClass: "ace-Common-highlight",

//         // Single regex pattern
//         pattern: /(\d+\.?\d*)\s*(mg|g|kg|ml|l|μl)\s*(-|to)\s*(\d+\.?\d*)\s*(mg|g|kg|ml|l|μl)/gi,

//         // getSuggestion as a function
//         getSuggestion: (matchedText) => {
//             return matchedText.replace(
//                 /(\d+\.?\d*)\s*(mg|g|kg|ml|l|μl)\s*(-|to)\s*(\d+\.?\d*)\s*(mg|g|kg|ml|l|μl)/gi,
//                 '$1 $3 $4$5'
//             );
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },

//     AddSpacing: {
//         name: "Adding space around symbols between numbers or letters",
//         description: "Add space around symbols only if numbers or letters are on both sides",
//         markerClass: "ace-Common-highlight",

//         // Match a letter/number/underscore, a symbol, then a letter/number/underscore
//         pattern: /(\w+)\s*(\+|\-|±|<|>|\/|\*)\s*(\w+)/g,

//         getSuggestion: (matchedText) =>
//             matchedText.replace(/(\w+)\s*(\+|\-|±|<|>|\/|\*)\s*(\w+)/, '$1 $2 $3'),

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },
//     NegativeValues: {
//         name: "Normalize Negative Values & Fractions",
//         description: "Handles negative numbers, fractions, word-number fractions, and special symbols",
//         markerClass: "ace-Common-highlight",

//         // Patterns for different transformations
//         pattern: [
//             /(^|\s)[-|−](\d+)/g,   // Negative numbers
//             /(^|\s)(\d+)\s*\/\s*(\d+)/g, // Fractions with spaces
//             /\b(one|two|three|four|five|six|seven|eight|nine|ten)\s+(half|halves|thirds?|quarters?|fourths?|fifths?|sixths?|sevenths?|eighths?|ninths?|tenths?)\b/gi, // Word fractions
//             /([A-Z]{2})\s*°\s*([A-Z]{2})\s*[’']\s*([A-Z])\s*[”"]/g, // Degree symbols formatting
//             /(\w)\s*-?\s*axis/g // x-axis, y-axis etc.
//         ],

//         getSuggestion: (text) => {
//             let result = text;

//             // 1. Normalize negative numbers
//             result = result.replace(/(^|\s)[-|−](\d+)/g, "$1-$2");

//             // 2. Remove spaces in numeric fractions
//             result = result.replace(/(^|\s)(\d+)\s*\/\s*(\d+)/g, (match, g1, g2, g3) => `${g1}${g2}/${g3}`);

//             // 3. Word fractions
//             result = result.replace(
//                 /\b(one|two|three|four|five|six|seven|eight|nine|ten)\s+(half|halves|thirds?|quarters?|fourths?|fifths?|sixths?|sevenths?|eighths?|ninths?|tenths?)\b/gi,
//                 "$1-$2"
//             );

//             // 4. Degree symbols formatting
//             result = result.replace(
//                 /([A-Z]{2})\s*°\s*([A-Z]{2})\s*[’']\s*([A-Z])\s*[”"]/g,
//                 '$1°$2′$3″'
//             );

//             // 5. x-axis, y-axis etc. → italic letters
//             result = result.replace(/(\w)\s*-?\s*axis/g, (match, p1) => {
//                 const italicMap = { x: '𝑥', y: '𝑦', z: '𝑧', X: '𝑋', Y: '𝑌', Z: '𝑍' };
//                 const italic = italicMap[p1] || p1;
//                 return `${italic}-axis`;
//             });

//             return result;
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },
//     commaInNumber: {
//         name: "Adding comma to numbers < 9999",
//         description: "Add commas to numbers for thousands separation, join numbers with spaces first",
//         markerClass: "ace-Common-highlight",

//         // Patterns:
//         // 1. Numbers with 4 or more digits without spaces
//         // 2. Numbers with spaces between digits (e.g., "333 333")
//         pattern: [
//             /\b\d{4,}\b/g,        // plain numbers >= 4 digits
//             /\b(\d+)\s+(\d+)\b/g  // numbers with spaces inside
//         ],

//         getSuggestion: (matchedText) => {
//             // Remove all spaces first
//             const num = matchedText.replace(/\s+/g, "");
//             // Add comma as thousand separator
//             return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },
//     dashclassification: {
//         name: "Normalize dash between numbers",
//         description: "Change dash, en-dash, em-dash with spaces to a single '-' between numbers",
//         markerClass: "ace-Common-highlight",

//         // Pattern: match numbers separated by dash variants with optional spaces
//         pattern: /(\d+)\s*[-–—]\s*(\d+)/gi,

//         // getSuggestion as a function
//         getSuggestion: (matchedText) => {
//             return matchedText.replace(/(\d+)\s*[-–—]\s*(\d+)/gi, "$1-$2");
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },




//     DecimalValues: {
//         name: "Normalize decimal values change 0,5 to 0.5",
//         description: "Ensure decimal separator is a dot",
//         markerClass: "ace-Common-highlight",

//         // Pattern matches numbers with comma or dot as decimal
//         pattern: /(\d+)[,\.](\d+)/g,

//         getSuggestion: (matchedText) => {
//             // Replace comma with dot
//             let text = matchedText.replace(/,/, ".");
//             // Handle cases like ".5" without leading zero
//             text = text.replace(/^(\.)/, "0.");
//             return text;
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },




//     RemovingSpacing: {
//         name: "Removing space on one side after a operator",
//         description: "Remove spaces before and after symbols",
//         markerClass: "ace-Common-highlight",

//         // Single regex pattern
//         pattern: /([\+±<>\-\.\*])\s+(\d+)/gmi,

//         // getSuggestion as a function
//         getSuggestion: (matchedText) => {
//             return matchedText.replace(/([\+±<>\-\.\*])\s+(\d+)/gmi, "$1$2");
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png"
//     },




//     // PATTERN AS ARRAY (as before)
//     RepeatingRanges: {
//         name: "Change the format of Ranges",
//         description: "Change the format of Ranges",
//         markerClass: "ace-Common-highlight",

//         pattern: [
//             /\((\d+)\s*[—-]\s*(\d+)%\)/g,
//             /\bfrom\s+(\d+)\s*[—-]\s*(\d+)%/gi,
//             /\bbetween\s+(\d+)\s*[—-]\s*(\d+)%/gi
//         ],

//         getSuggestion: (matchedText, patternIndex) => {
//             if (patternIndex === 0) {
//                 return matchedText.replace(/\((\d+)\s*[—-]\s*(\d+)%\)/g, '($1%--$2%)');
//             } else if (patternIndex === 1) {
//                 return matchedText.replace(/\bfrom\s+(\d+)\s*[—-]\s*(\d+)%/gi, 'from $1% to $2%');
//             } else if (patternIndex === 2) {
//                 return matchedText.replace(/\bbetween\s+(\d+)\s*[—-]\s*(\d+)%/gi, 'between $1% and $2%');
//             }
//             return matchedText;
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },

//     // PATTERN AS FUNCTION - COMPLEX LOGIC
//     TimeAndDosageFormatting: {
//         name: "Time & Dosage Formatting",
//         description: "Abbreviates units only in numeric or dosage context",
//         markerClass: "ace-Common-highlight",

//         // Pattern is a FUNCTION that returns an array of patterns
//         pattern: () => {
//             const units = {
//                 "second": "sec",
//                 "minute": "min",
//                 "hour": "hr",
//                 "day": "d",
//                 "week": "wk",
//                 "year": "y",
//                 "milligram": "mg",
//                 "milliliter": "ml"
//             };

//             // Generate patterns dynamically for each unit
//             const patterns = [];
//             for (const [full, short] of Object.entries(units)) {
//                 // Match unit words in numeric context
//                 patterns.push(new RegExp(`\\d+\\s*\\/?.{0,10}?\\b${full}\\b`, "gi"));
//             }

//             return patterns;
//         },

//         getSuggestion: (matchedText, patternIndex) => {
//             const units = ["second", "minute", "hour", "day", "week", "year", "milligram", "milliliter"];
//             const abbreviations = ["sec", "min", "hr", "d", "wk", "y", "mg", "ml"];

//             // Replace the full unit name with abbreviation
//             return matchedText.replace(
//                 new RegExp(`\\b${units[patternIndex]}\\b`, "gi"),
//                 abbreviations[patternIndex]
//             );
//         },

//         beforeImage: "/images/description/TimeAndDosageBefore.png",
//         afterImage: "/images/description/TimeAndDosageAfter.png",
//     },
//     LatexLabels: {
//         name: "Latex Labels",
//         description: "Ensure citations use appropriate LaTeX labels",
//         markerClass: "ace-Common-highlight",

//         pattern: () => {
//             const labelTypes = [
//                 // Existing numeric style: Equation (1)
//                 { prefix: "Equation|Eq\\.", type: "eqn", mode: "number" },
//                 { prefix: "Table", type: "table", mode: "number" },
//                 { prefix: "Figure|Fig\\.", type: "fig", mode: "number" },

//                 // NEW: Equation~\ref{eqn1} → Equation~\eqref{eqn1}
//                 { prefix: "Equation|Eq\\.", type: "eqn", mode: "eqref" }
//             ];

//             return labelTypes.map(({ prefix, mode }) => {
//                 if (mode === "number") {
//                     return new RegExp(`\\b(${prefix})\\s*\\((\\d+)\\)`, "gi");
//                 }

//                 // Equation~\ref{eqn1}
//                 return new RegExp(`\\b(${prefix})\\s*~?\\\\ref\\{(eqn\\d+)\\}`, "gi");
//             });
//         },

//         getSuggestion: (matchedText, patternIndex, fullMatch) => {
//             // First 3 patterns are numeric → \ref{typeX}
//             if (patternIndex <= 2) {
//                 const refTypes = ["eqn", "table", "fig"];
//                 const label = fullMatch[1];
//                 const num = fullMatch[2];

//                 return `${label} (\\ref{${refTypes[patternIndex]}${num}})`;
//             }

//             // Last pattern: Equation~\ref{eqn1} → Equation~\eqref{eqn1}
//             const label = fullMatch[1];
//             const eqnLabel = fullMatch[2];

//             return `${label}~\\eqref{${eqnLabel}}`;
//         },

//         beforeImage: "/images/description/LatexLabelsBefore.png",
//         afterImage: "/images/description/LatexLabelsAfter.png",
//     },
//     RemoveCommentedText: {
//         name: "Remove Commented Text",
//         description: "Removes the commented text that are specified by % symbol.",
//         pattern: /(?<!\\)%[^\n\r]*/g,
//         markerClass: "ace-Common-highlight",

//         getSuggestion: () => {
//             return "";
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },
//     EmDashSpacing: {
//         name: "Em-dash Space",
//         description: "Remove space before and after em-dash (---)",
//         markerClass: "ace-Common-highlight",

//         // Match spaces around em-dash
//         pattern: /(\w+)\s*---\s*(\w+)/g,

//         // Suggestion: remove spaces around the em-dash
//         getSuggestion: (matchedText, patternIndex, fullMatch) => {
//             return `${fullMatch[1]}---${fullMatch[2]}`;
//         },

//         beforeImage: "/images/description/RemoveCommandBefore.png",
//         afterImage: "/images/description/RemoveCommandAfter.png",
//     },
//     HeadingCase: {
//         name: "Heading Case",
//         description: "Convert all \\section, \\subsection, and \\subsubsection headings to Title Case",
//         markerClass: "ace-Common-highlight",

//         // Pattern matches the content inside \section{}, \subsection{}, \subsubsection{}
//         pattern: /\\(section|subsection|subsubsection)\{([^}]+)\}/g,

//         getSuggestion: (matchedText, patternIndex, fullMatch) => {
//             const headingType = fullMatch[1]; // section, subsection, subsubsection
//             const headingContent = fullMatch[2];

//             // Convert heading content to Title Case
//             const titleCased = headingContent
//                 .split(/(\s+)/) // keep spaces
//                 .map(word => {
//                     // Keep small words (like 'and', 'of', 'the') lowercase if needed
//                     const lowerWords = ["and", "or", "the", "of", "in", "on", "for", "with", "a", "an"];
//                     if (lowerWords.includes(word.toLowerCase())) return word.toLowerCase();
//                     return word.charAt(0).toUpperCase() + word.slice(1);
//                 })
//                 .join("");

//             return `\\${headingType}{${titleCased}}`;
//         },

//         beforeImage: "/images/description/HeadingCaseBefore.png",
//         afterImage: "/images/description/HeadingCaseAfter.png"
//     }


// };


import { createAnchor, getPositionFromIndex } from "./AutoSuggestion";

export const eplStyles = {
    ThousandSeparator: {
        name: "Thousand Separator",
        description: "Add commas to numbers",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Define regex pattern
            const pattern = /\b\d{4,}\b/g;
            let match;

            // Find all matches
            while ((match = pattern.exec(texFile)) !== null) {
                const matchedText = match[0];

                // Calculate suggestion
                const suggestion = matchedText.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                // Get position
                const position = getPositionFromIndex(texFile, match.index, matchedText.length);

                // Create anchor and add to list
                createAnchor(
                    session,
                    Range,
                    position,
                    matchedText,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },
    RemoveDuplicateReferences: {
        name: "Remove Duplicate References",
        description: "Remove duplicate bibliography entries, keeping only the first occurrence",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            const bibitemRegex =
                /\\bibitem\{.*?\}%?\d*\s*([\s\S]*?)(?=\\bibitem|\\end\{thebibliography\})/g;

            const seen = new Map(); // normalizedContent → first occurrence index
            let match;

            while ((match = bibitemRegex.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const refContent = match[1];

                // Normalize reference content to detect duplicates
                const normalized = refContent
                    .replace(/\s+/g, " ")
                    .replace(/[{}]/g, "")
                    .toLowerCase()
                    .trim();

                if (seen.has(normalized)) {
                    // Duplicate found → mark for removal
                    const position = getPositionFromIndex(
                        texFile,
                        match.index,
                        fullMatch.length
                    );

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        "", // Suggestion = remove duplicate
                        this.markerClass,
                        this.name,
                        "Duplicate reference detected. Remove this entry.",
                        anchorlist
                    );
                } else {
                    // First occurrence → store
                    seen.set(normalized, match.index);
                }
            }
        }
    },

    TemperatureFormatting: {
        name: "Temperature Formatting",
        description: "Remove space before and after °",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            // Matches: 100 ° C, 37° C, 25 °C → captures number + unit
            const pattern = /(\d+)\s*°\s*([A-Z]{1,2})/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const value = match[1];
                const unit = match[2];

                // Correct format: 100°C
                const suggestion = `${value}°${unit}`;

                const position = getPositionFromIndex(
                    texFile,
                    match.index,
                    fullMatch.length
                );

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },
    PFormatting: {
        name: "Formatting the p",
        description: "Change standalone statistical p to italic 𝑝",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            // Examples matched: " p ", "p < 0.05", "p=0.01"
            const pattern = /(?<![A-Za-z])p(?=\s*[<>=])/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = "𝑝";

                const position = getPositionFromIndex(
                    texFile,
                    match.index,
                    fullMatch.length
                );

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },



    TimeFormat: {
        name: "Time Format",
        description: "Convert AM/PM to a.m./p.m.",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\b(AM|PM)\b/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const matchedText = match[0];
                const suggestion = matchedText.toLowerCase() === "am" ? "a.m." : "p.m.";

                const position = getPositionFromIndex(texFile, match.index, matchedText.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    matchedText,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    PercentageSymbol: {
        name: "Change Percentage to %",
        description: "Change Percentage words to %",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\b(\d+)\s*(percent|percentage)\b/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const matchedText = match[0];
                const suggestion = matchedText.replace(/\b(\d+)\s*(percent|percentage)\b/gi, "$1%");

                const position = getPositionFromIndex(texFile, match.index, matchedText.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    matchedText,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 1. Heading Case - Title Case for section, subsection, subsubsection
    HeadingTitleCase: {
        name: "Heading Title Case",
        description: "All headings should be in Title Case",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Match section, subsection, and subsubsection
            const pattern = /\\(section|subsection|subsubsection)\{([^}]+)\}/g;
            const lowercaseWords = new Set(['is', 'was', 'are', 'were', 'the', 'a', 'an', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'as', 'by', 'from']);
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const commandType = match[1]; // section, subsection, or subsubsection
                const title = match[2];
                const words = title.split(/\s+/);

                let needsCorrection = false;
                const correctedWords = words.map((word, index) => {
                    // First word should always be capitalized
                    if (index === 0) {
                        if (word[0] !== word[0].toUpperCase()) {
                            needsCorrection = true;
                            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                        }
                        return word;
                    }

                    // Check if word should be lowercase (articles, conjunctions, prepositions)
                    if (lowercaseWords.has(word.toLowerCase())) {
                        if (word !== word.toLowerCase()) {
                            needsCorrection = true;
                            return word.toLowerCase();
                        }
                        return word;
                    }

                    // Other words should be capitalized
                    if (word[0] !== word[0].toUpperCase()) {
                        needsCorrection = true;
                        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    }

                    return word;
                });

                if (needsCorrection) {
                    const correctedTitle = correctedWords.join(' ');
                    const suggestion = `\\${commandType}{${correctedTitle}}`;

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
        }
    },

    // 2. Figure Captions - Sentence case with period
    FigureCaptions: {
        name: "Figure Caption Sentence Case",
        description: "Figure captions should be sentence case and end with period",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Match \caption inside figure environment
            const figurePattern = /\\begin\{figure\}[\s\S]*?\\caption\{([^}]+)\}[\s\S]*?\\end\{figure\}/g;
            let match;

            while ((match = figurePattern.exec(texFile)) !== null) {
                const captionText = match[1];

                // Check if it needs correction (not sentence case or missing period)
                const firstChar = captionText.trim()[0];
                const lastChar = captionText.trim().slice(-1);
                const hasUppercaseWords = /[A-Z][a-z]*\s+[A-Z]/.test(captionText);

                if (firstChar !== firstChar.toUpperCase() || lastChar !== '.' || hasUppercaseWords) {
                    // Convert to sentence case
                    const sentenceCase = captionText.charAt(0).toUpperCase() +
                        captionText.slice(1).toLowerCase();

                    // Add period if missing
                    const corrected = sentenceCase.endsWith('.') ? sentenceCase : sentenceCase + '.';

                    // Find the exact position of \caption{...}
                    const captionMatch = texFile.substring(match.index).match(/\\caption\{([^}]+)\}/);
                    if (captionMatch) {
                        const captionStartIndex = match.index + captionMatch.index;
                        const fullCaption = captionMatch[0];
                        const suggestion = `\\caption{${corrected}}`;

                        const position = getPositionFromIndex(texFile, captionStartIndex, fullCaption.length);

                        createAnchor(
                            session,
                            Range,
                            position,
                            fullCaption,
                            suggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
        }
    },

    // 3. Table Captions - Sentence case with period
    TableCaptions: {
        name: "Table Caption Sentence Case",
        description: "Table captions should be sentence case and end with period",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Match \caption inside table environment
            const tablePattern = /\\begin\{table\}[\s\S]*?\\caption\{([^}]+)\}[\s\S]*?\\end\{table\}/g;
            let match;

            while ((match = tablePattern.exec(texFile)) !== null) {
                const captionText = match[1];

                const firstChar = captionText.trim()[0];
                const lastChar = captionText.trim().slice(-1);
                const hasUppercaseWords = /[A-Z][a-z]*\s+[A-Z]/.test(captionText);

                if (firstChar !== firstChar.toUpperCase() || lastChar !== '.' || hasUppercaseWords) {
                    const sentenceCase = captionText.charAt(0).toUpperCase() +
                        captionText.slice(1).toLowerCase();
                    const corrected = sentenceCase.endsWith('.') ? sentenceCase : sentenceCase + '.';

                    const captionMatch = texFile.substring(match.index).match(/\\caption\{([^}]+)\}/);
                    if (captionMatch) {
                        const captionStartIndex = match.index + captionMatch.index;
                        const fullCaption = captionMatch[0];
                        const suggestion = `\\caption{${corrected}}`;

                        const position = getPositionFromIndex(texFile, captionStartIndex, fullCaption.length);

                        createAnchor(
                            session,
                            Range,
                            position,
                            fullCaption,
                            suggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                }
            }
        }
    },

    // 4. Em-dash Space - Remove spaces around em-dash
    EmDashSpacing: {
        name: "Em-dash Spacing",
        description: "No space before and after em-dash",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\s+---\s+/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = '---';

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 5. Slash Spacing - Remove spaces around slash
    SlashSpacing: {
        name: "Slash Spacing",
        description: "No space before and after a slash",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /(\w+)\s+\/\s+(\w+)/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const word1 = match[1];
                const word2 = match[2];
                const suggestion = `${word1}/${word2}`;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 6. Versus Usage
    VersusUsage: {
        name: "Versus Usage",
        description: "Spell out 'versus' outside parenthesis, abbreviate 'vs.' inside",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Pattern 1: "versus" inside parenthesis -> should be "vs."
            const pattern1 = /\([^)]*\bversus\b[^)]*\)/gi;
            let match;

            while ((match = pattern1.exec(texFile)) !== null) {
                const fullMatch = match[0];
                if (fullMatch.toLowerCase().includes('versus')) {
                    const suggestion = fullMatch.replace(/\bversus\b/gi, 'vs.');

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }

            // Pattern 2: "vs." outside parenthesis -> should be "versus"
            const pattern2 = /(?<!\()\b\w+\s+vs\.\s+\w+\b(?!\))/gi;
            pattern2.lastIndex = 0;

            while ((match = pattern2.exec(texFile)) !== null) {
                // Check if it's actually outside parenthesis
                const before = texFile.substring(Math.max(0, match.index - 50), match.index);
                const after = texFile.substring(match.index + match[0].length, match.index + match[0].length + 50);

                // Simple check: count open and close parens
                const openBefore = (before.match(/\(/g) || []).length;
                const closeBefore = (before.match(/\)/g) || []).length;

                if (openBefore === closeBefore) { // Outside parenthesis
                    const fullMatch = match[0];
                    const suggestion = fullMatch.replace(/\bvs\./gi, 'versus');

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
        }
    },

    // 7. Section Callout Capitalization
    SectionCallout: {
        name: "Section Callout Capitalization",
        description: "Capitalize 'Section' in section callouts",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\bsection\s*(~)?\\ref\{/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                if (match[0].startsWith('section')) { // lowercase 'section'
                    const fullMatch = match[0];
                    const tilde = match[1] || '';
                    const suggestion = `Section${tilde ? '~' : ' '}\\ref{`;

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
        }
    },

    // 8. Delete Repeated Words
    RepeatedWords: {
        name: "Delete Repeated Words",
        description: "Remove duplicate consecutive words",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\b(\w+)\s+\1\b/gi;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const repeatedWord = match[1];
                const suggestion = repeatedWord;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 9. Single to Double Quotes
    SingleToDoubleQuotes: {
        name: "Single to Double Quotes",
        description: "Change single quotes to double quotes",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\s'([^']+)'/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const quotedText = match[1];
                const suggestion = `"${quotedText}"`;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 10. Latin Terms Italic
    LatinTermsItalic: {
        name: "Latin Terms Italic",
        description: "Latin terms should be italicized",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const latinTerms = [
                'in vitro', 'in vivo', 'via', 'in situ', 'et al', 'etc', 'i.e.', 'e.g.',
                'cf.', 'vs.', 'vice versa', 'ad hoc', 'a priori', 'a posteriori',
                'de facto', 'de jure', 'per se', 'inter alia', 'ex post', 'ex ante'
            ];

            latinTerms.forEach(term => {
                const escapedTerm = term.replace(/\./g, '\\.');
                const pattern = new RegExp(`(?<!\\\\textit\\{)\\b${escapedTerm}\\b(?!\\})`, 'gi');
                let match;

                while ((match = pattern.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = `\\textit{${fullMatch}}`;

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            });
        }
    },

    // 11. Equation Citation - Use \eqref instead of \ref
    EquationCitation: {
        name: "Equation Citation",
        description: "Use \\eqref{} instead of (\\ref{})",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Pattern: Equation~\ref{...} or Equation \ref{...}
            const pattern1 = /Equation~?\\ref\{([^}]+)\}/g;
            let match;

            while ((match = pattern1.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const label = match[1];
                const suggestion = `Equation~\\eqref{${label}}`;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }

            // Pattern: (\ref{...})
            const pattern2 = /\(\\ref\{([^}]+)\}\)/g;
            pattern2.lastIndex = 0;

            while ((match = pattern2.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const label = match[1];
                const suggestion = `\\eqref{${label}}`;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 12. Ordinal Numbers
    OrdinalNumbers: {
        name: "Ordinal Numbers",
        description: "Ordinal numbers should be inline, not superscript",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            // Pattern: 50$^{\rm th}$ or $50^{th}$ -> 50th
            const pattern = /(\d+)\$?\^\{\\rm\s+(st|nd|rd|th)\}\$?|\$(\d+)\^\{(st|nd|rd|th)\}\$/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const number = match[1] || match[3];
                const suffix = match[2] || match[4];
                const suggestion = `${number}${suffix}`;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    // 13. Remove Hidden Text (Comments)
    RemoveHiddenText: {
        name: "Remove Hidden Text",
        description: "Remove commented/hidden text from LaTeX",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /(?<!\\)%.*$/gm;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = '';

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    LatexCommandSpacing: {
        name: "LaTeX Command Spacing",
        description: "Ensure proper spacing after LaTeX commands",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\\(cite|ref|label)\{[^}]+\}([a-zA-Z])/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const nextChar = match[2];
                const suggestion = fullMatch.slice(0, -1) + ' ' + nextChar;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    ConsistentQuotes: {
        name: "Consistent Quote Marks",
        description: "Use LaTeX quote marks (`` and '')",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /"([^"]+)"/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const quotedText = match[1];
                const suggestion = `\`\`${quotedText}''`;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                createAnchor(
                    session,
                    Range,
                    position,
                    fullMatch,
                    suggestion,
                    this.markerClass,
                    this.name,
                    this.description,
                    anchorlist
                );
            }
        }
    },

    RepeatingRanges: {
        name: "Format Ranges",
        description: "Format number ranges properly",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            const rules = [
                // (10-20%)
                {
                    pattern: /\((\d+)\s*[—-]\s*(\d+)%\)/g,
                    suggest: (m) => `(${m[1]}%--${m[2]}%)`
                },

                // from 10-20%
                {
                    pattern: /\bfrom\s+(\d+)\s*[—-]\s*(\d+)%/gi,
                    suggest: (m) => `from ${m[1]}% to ${m[2]}%`
                },

                // between 10-20%
                {
                    pattern: /\bbetween\s+(\d+)\s*[—-]\s*(\d+)%/gi,
                    suggest: (m) => `between ${m[1]}% and ${m[2]}%`
                }
            ];

            rules.forEach(({ pattern, suggest }) => {
                let match;
                pattern.lastIndex = 0;

                while ((match = pattern.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = suggest(match);

                    const position = getPositionFromIndex(
                        texFile,
                        match.index,
                        fullMatch.length
                    );

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            });
        }
    },


    EquationNumbering: {
        name: "Equation Numbering",
        description: "Ensure equations have labels",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /\\begin\{equation\}([\s\S]*?)\\end\{equation\}/g;
            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const equationContent = match[1];

                // Check if it has a label
                if (!equationContent.includes('\\label{')) {
                    const suggestion = fullMatch.replace(
                        '\\end{equation}',
                        '\\label{eq:unnamed}\n\\end{equation}'
                    );

                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                    createAnchor(
                        session,
                        Range,
                        position,
                        fullMatch,
                        suggestion,
                        this.markerClass,
                        this.name,
                        this.description,
                        anchorlist
                    );
                }
            }
        }
    },
    TimeAndDosageFormatting: {
        name: "Normalize Time/Dosage Ratios",
        description: "Convert unit ratios like second/day to sec/d",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            const unitMap = {
                second: "sec",
                seconds: "sec",
                sec: "sec",

                minute: "min",
                minutes: "min",
                min: "min",

                hour: "h",
                hours: "h",
                h: "h",

                day: "d",
                days: "d",
                d: "d",

                milligram: "mg",
                milligrams: "mg",
                mg: "mg",

                gram: "g",
                grams: "g",
                g: "g"
            };

            // Match: unit/unit (no numbers involved)
            const pattern = new RegExp(
                `\\b(${Object.keys(unitMap).join("|")})\\s*\\/\\s*(${Object.keys(unitMap).join("|")})\\b`,
                "gi"
            );

            let match;

            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0]; // e.g. "second/day"
                const leftUnit = match[1].toLowerCase();
                const rightUnit = match[2].toLowerCase();

                const suggestion = `${unitMap[leftUnit]}/${unitMap[rightUnit]}`;

                const position = getPositionFromIndex(
                    texFile,
                    match.index,
                    fullMatch.length
                );
                createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);

            }
        }
    },
    LatexCitations: {
        name: "LaTeX Citations",
        description: "Convert Equation, Table, and Figure references to LaTeX \\ref{} format",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            const rules = [
                {
                    pattern: /\b(Equation|Eq\.)\s*\((\d+)\)/gi,
                    suggest: (m) => `${m[1]} (\\ref{eqn${m[2]}})`
                },
                {
                    pattern: /\b(Table)\s+(\d+)\b/gi,
                    suggest: (m) => `${m[1]} \\ref{table-${m[2]}}`
                },
                {
                    pattern: /\b(Tables)\s+(\d+)\s+to\s+(\d+)\b/gi,
                    suggest: (m) =>
                        `${m[1]} \\ref{table-${m[2]}} to \\ref{table-${m[3]}}`
                },
                {
                    pattern: /\b(Figure|Fig\.)\s+(\d+)\b/gi,
                    suggest: (m) => `${m[1]} \\ref{fig-${m[2]}}`
                }
            ];

            rules.forEach(({ pattern, suggest }) => {
                let match;
                pattern.lastIndex = 0;

                while ((match = pattern.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = suggest(match);

                    const position = getPositionFromIndex(
                        texFile,
                        match.index,
                        fullMatch.length
                    );
                    createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);

                }
            });
        }
    },
    AdjustMathBrackets: {
        name: "Adjust Math Brackets",
        description: "Add \\left and \\right to brackets enclosing math constructs inside equation environments only",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {

            const equationPattern = /\\begin\{equation\}([\s\S]*?)\\end\{equation\}/g;
            const targets = "\\\\(frac|sum|int|prod)";

            const rules = [
                {
                    pattern: new RegExp(`(?<!\\\\left)\\(([^()]*${targets}[\\s\\S]*?)\\)`, "g"),
                    wrap: (inner) => `\\left(${inner}\\right)`
                },
                {
                    pattern: new RegExp(`(?<!\\\\left)\\\\\\{([^{}]*${targets}[\\s\\S]*?)\\\\\\}`, "g"),
                    wrap: (inner) => `\\left\\{${inner}\\right\\}`
                },
                {
                    pattern: new RegExp(`(?<!\\\\left)\\[([^\\[\\]]*${targets}[\\s\\S]*?)\\]`, "g"),
                    wrap: (inner) => `\\left[${inner}\\right]`
                },
                {
                    pattern: new RegExp(`(?<!\\\\left)\\|([^|]*${targets}[\\s\\S]*?)\\|`, "g"),
                    wrap: (inner) => `\\left|${inner}\\right|`
                }
            ];

            let eqMatch;
            while ((eqMatch = equationPattern.exec(texFile)) !== null) {

                const equationBody = eqMatch[1];
                const equationStartIndex =
                    eqMatch.index + eqMatch[0].indexOf(equationBody);

                rules.forEach(({ pattern, wrap }) => {
                    let match;
                    pattern.lastIndex = 0;

                    while ((match = pattern.exec(equationBody)) !== null) {

                        const fullMatch = match[0];
                        const inner = match[1];
                        const suggestion = wrap(inner);

                        const absoluteIndex = equationStartIndex + match.index;

                        const position = getPositionFromIndex(
                            texFile,
                            absoluteIndex,
                            fullMatch.length
                        );

                        createAnchor(
                            session,
                            Range,
                            position,
                            fullMatch,
                            suggestion,
                            this.markerClass,
                            this.name,
                            this.description,
                            anchorlist
                        );
                    }
                });
            }
        }
    },
    // URLValidation: {
    //     name: "Invalid URL or DOI",
    //     description: "Validates URLs and DOIs, marks invalid ones",
    //     markerClass: "ace-Common-highlight",

    //     execute: async function (texFile, session, Range, anchorlist) {

    //         // Helper function to validate a link
    //         const validateLink = async (link) => {
    //             try {
    //                 console.log("Validating link:", link);
    //                 const response = await fetch(link, {
    //                     method: "HEAD",
    //                     redirect: "follow"
    //                 });
    //                 console.log("Response status:", response.status);
    //                 // Only treat 404 as invalid
    //                 if (response.status === 404) {
    //                     return { valid: false, reason: "404 Not Found" };
    //                 }
    //                 return { valid: true };
    //             } catch (error) {
    //                 console.log("Fetch error:", error.message);
    //                 // For CORS errors or network issues, we'll mark as "needs checking"
    //                 return { valid: false, reason: "Unable to verify (CORS or network error)" };
    //             }
    //         };

    //         // Pattern 1: Find bare URLs (not already in \url{} or \href{})
    //         const urlPattern = /(?<!\\url\{|\\href\{)(https?:\/\/[^\s\}\),]+)/gi;
    //         let match;

    //         const urlMatches = [];
    //         while ((match = urlPattern.exec(texFile)) !== null) {
    //             urlMatches.push({
    //                 url: match[1],
    //                 index: match.index,
    //                 length: match[1].length
    //             });
    //         }

    //         console.log("Found bare URLs:", urlMatches.length);

    //         // Pattern 2: Find DOIs in format DOI:10.xxxx/xxxx
    //         const doiPattern = /(DOI:10\.\d{4,9}\/[^\s\),]+)/gi;

    //         const doiMatches = [];
    //         doiPattern.lastIndex = 0;
    //         while ((match = doiPattern.exec(texFile)) !== null) {
    //             doiMatches.push({
    //                 doi: match[1],
    //                 index: match.index,
    //                 length: match[1].length
    //             });
    //         }

    //         console.log("Found DOIs:", doiMatches.length, doiMatches);

    //         // Validate all URLs
    //         for (const urlMatch of urlMatches) {
    //             const result = await validateLink(urlMatch.url);

    //             console.log("URL validation result:", urlMatch.url, result);

    //             if (!result.valid) {
    //                 const position = getPositionFromIndex(
    //                     texFile,
    //                     urlMatch.index,
    //                     urlMatch.length
    //                 );

    //                 createAnchor(
    //                     session,
    //                     Range,
    //                     position,
    //                     urlMatch.url,
    //                     `\\url{${urlMatch.url}}`,
    //                     this.markerClass,
    //                     this.name,
    //                     `Invalid URL (${result.reason}): ${urlMatch.url}`,
    //                     anchorlist
    //                 );
    //             }
    //         }

    //         // Validate all DOIs
    //         for (const doiMatch of doiMatches) {
    //             // Convert DOI to URL for validation
    //             const doiNumber = doiMatch.doi.replace(/^DOI:/i, '').trim();
    //             const doiUrl = `https://doi.org/${doiNumber}`;

    //             console.log("Checking DOI:", doiMatch.doi, "->", doiUrl);

    //             const result = await validateLink(doiUrl);

    //             console.log("DOI validation result:", doiMatch.doi, result);

    //             if (!result.valid) {
    //                 const position = getPositionFromIndex(
    //                     texFile,
    //                     doiMatch.index,
    //                     doiMatch.length
    //                 );

    //                 createAnchor(
    //                     session,
    //                     Range,
    //                     position,
    //                     doiMatch.doi,
    //                     `\\href{${doiUrl}}{${doiMatch.doi}}`,
    //                     this.markerClass,
    //                     this.name,
    //                     `Invalid DOI (${result.reason}): ${doiMatch.doi}`,
    //                     anchorlist
    //                 );
    //             }
    //         }

    //         // Pattern 3: Check URLs already inside \url{} and \href{}
    //         const wrappedUrlPattern = /\\(?:url|href)\{(https?:\/\/[^\}]+)\}/gi;

    //         const wrappedMatches = [];
    //         wrappedUrlPattern.lastIndex = 0;
    //         while ((match = wrappedUrlPattern.exec(texFile)) !== null) {
    //             wrappedMatches.push({
    //                 fullMatch: match[0],
    //                 url: match[1],
    //                 index: match.index,
    //                 length: match[0].length
    //             });
    //         }

    //         console.log("Found wrapped URLs:", wrappedMatches.length);

    //         // Validate wrapped URLs
    //         for (const wrappedMatch of wrappedMatches) {
    //             const result = await validateLink(wrappedMatch.url);

    //             console.log("Wrapped URL validation result:", wrappedMatch.url, result);

    //             if (!result.valid) {
    //                 const position = getPositionFromIndex(
    //                     texFile,
    //                     wrappedMatch.index,
    //                     wrappedMatch.length
    //                 );

    //                 createAnchor(
    //                     session,
    //                     Range,
    //                     position,
    //                     wrappedMatch.fullMatch,
    //                     wrappedMatch.fullMatch + ' % ERROR: URL returns ' + result.reason,
    //                     this.markerClass,
    //                     this.name,
    //                     `URL validation failed (${result.reason}): ${wrappedMatch.url}`,
    //                     anchorlist
    //                 );
    //             }
    //         }

    //         console.log("Total anchors created:", anchorlist.length);
    //     }
    // },
    AddSpacing: {
        name: "Adding Space Around Symbols",
        description: "Add space around symbols only if numbers or letters are on both sides",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /(\w+)(\+|\-|±|<|>|\/|\*)(\w+)/g;
            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = `${match[1]} ${match[2]} ${match[3]}`;
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);
                createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
            }
        }
    },

    NegativeValues: {
        name: "Normalize Negative Values & Fractions",
        description: "Handles negative numbers, fractions, word-number fractions, and special symbols",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const patterns = [
                { regex: /(^|\s)[-|−](\d+)/g, replacer: (m, g1, g2) => `${g1}-${g2}` },
                { regex: /(^|\s)(\d+)\s*\/\s*(\d+)/g, replacer: (m, g1, g2, g3) => `${g1}${g2}/${g3}` },
                { regex: /\b(one|two|three|four|five|six|seven|eight|nine|ten)\s+(half|halves|thirds?|quarters?|fourths?|fifths?|sixths?|sevenths?|eighths?|ninths?|tenths?)\b/gi, replacer: (m, g1, g2) => `${g1}-${g2}` },
                { regex: /([A-Z]{2})\s*°\s*([A-Z]{2})\s*[’']\s*([A-Z])\s*[”"]/g, replacer: (m, g1, g2, g3) => `${g1}°${g2}′${g3}″` },
                {
                    regex: /(\w)\s*-?\s*axis/g, replacer: (m, g1) => {
                        const italicMap = { x: '𝑥', y: '𝑦', z: '𝑧', X: '𝑋', Y: '𝑌', Z: '𝑍' };
                        return `${italicMap[g1] || g1}-axis`;
                    }
                }
            ];

            patterns.forEach(({ regex, replacer }) => {
                let match;
                while ((match = regex.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = replacer(...match);
                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);
                    createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
                }
            });
        }
    },

    commaInNumber: {
        name: "Adding Commas to Numbers > 9999",
        description: "Add commas to numbers for thousands separation, skip 4-digit numbers",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const patterns = [
                {
                    // Numbers with 5 or more digits
                    regex: /\b\d{5,}\b/g,
                    replacer: (m) => m.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                {
                    // Numbers with spaces between digits, remove spaces first
                    regex: /\b(\d+)\s+(\d+)\b/g,
                    replacer: (m) => {
                        const num = m.replace(/\s+/g, "");
                        return num.length > 4 ? num.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : num;
                    }
                }
            ];

            patterns.forEach(({ regex, replacer }) => {
                let match;
                while ((match = regex.exec(texFile)) !== null) {
                    const fullMatch = match[0];
                    const suggestion = replacer(fullMatch);
                    const position = getPositionFromIndex(texFile, match.index, fullMatch.length);
                    createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
                }
            });
        }
    },


    dashclassification: {
        name: "Normalize Dash Between Numbers",
        description: "Change dash, en-dash, em-dash with spaces to a single '-' between numbers",
        markerClass: "ace-Common-highlight",

        execute: function (texFile, session, Range, anchorlist) {
            const pattern = /(\d+)\s*[-–—]\s*(\d+)/gi;
            let match;
            while ((match = pattern.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = `${match[1]}-${match[2]}`;
                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);
                createAnchor(session, Range, position, fullMatch, suggestion, this.markerClass, this.name, this.description, anchorlist);
            }
        }
    },

};
